import {
    GiftCardFormChangePassword,
    GiftCardFormChangePasswordProps,
    Form,
} from './GiftCardFormChangePassword';
export type { GiftCardFormChangePasswordProps, Form };
export default GiftCardFormChangePassword;
